import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { isEnableDisplayDepartmentTel } from "../../../../utils/userUtils";
import { formatDepartmentTel } from '../../../../utils/executiveListUtils';
import ArrowToolTip from "../../../common/ArrowToolTip";
import FollowCall from "../../../Icons/FollowCall";

const styles = () => ({
  root: {
    height: '100%',
    width: '35px',
    marginRight: "12px",
  },
  tooltipContainer: {
    background: '#F2F6FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: '35px',
    height: '35px',
  },
});

const DepartmentTel = ({ classes, item, user }) => {
  if (!item.department_tels) {
    return <div className={classes.root} />;
  }

  const tooltipText = isEnableDisplayDepartmentTel(user)
    ? formatDepartmentTel(item)
    : "この機能をご利用いただくには\nオプションの変更が必要です。\n右下のチャットフォームより\nお問い合わせくださいませ。";

  return (
    <div className={classes.root}>
      <div className={classes.tooltipContainer}>
        <ArrowToolTip
          text={tooltipText}
          tooltipMaxWidth={"300"}
          style={{ whiteSpace: "pre"}}
        >
          <FollowCall width={17} height={17} color="#6F9EFF" />
        </ArrowToolTip>
      </div>
    </div>
  );
};

DepartmentTel.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default withStyles(styles)(DepartmentTel);




// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/cols/DepartmentTel.jsx